
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insfordoctors",
      function () {
        return require("private-next-pages/insfordoctors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insfordoctors"])
      });
    }
  